import React from 'react';

const SecondaryColorLogo = function SecondaryColorLogo() {
  return (
    <svg
      width="23px"
      height="22px"
      viewBox="0 0 23 22"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>User Account</title>
      <g id="Client-Prototype" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Companies" transform="translate(-1223.000000, -198.000000)">
          <g id="Group-57" transform="translate(1212.000000, 190.000000)">
            <g id="mode_edit_black_24dp" transform="translate(11.354841, 8.000000)">
              <rect id="Rectangle" x="0" y="0" width="22" height="22" />
              <g id="Group" transform="translate(2.750000, 2.747708)" fill="#424B50" fillRule="nonzero">
                <path d="M0,16.5022917 L3.4375,16.5022917 L13.5758333,6.36395833 L10.1383333,2.92645833 L0,13.0647917 L0,16.5022917 Z M1.83333333,13.825625 L10.1383333,5.520625 L10.9816667,6.36395833 L2.67666667,14.6689583 L1.83333333,14.6689583 L1.83333333,13.825625 Z" id="Shape" />
                <path d="M14.0891667,0.268125 C13.7316667,-0.089375 13.1541667,-0.089375 12.7966667,0.268125 L11.1191667,1.945625 L14.5566667,5.383125 L16.2341667,3.705625 C16.5916667,3.348125 16.5916667,2.770625 16.2341667,2.413125 L14.0891667,0.268125 Z" id="Path" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default SecondaryColorLogo;
